/* esm.sh - rxjs@7.8.2/dist/esm/internal/observable/interval */
import{asyncScheduler as m}from"rxjs/dist/esm/internal/scheduler/async";import{timer as n}from"rxjs/dist/esm/internal/observable/timer";function e(r=0,t=m){return r<0&&(r=0),n(r,r,t)}export{e as interval};
//# sourceMappingURL=interval.mjs.map